import React from 'react';
import right from '../Assets/Group 35.png'
import big from '../Assets/Ellipse 9.png'
import small from '../Assets/Ellipse 8.png'
import arc from '../Assets/Group 100.png'

export default function Plans() {
  return (
    <>
      <div className="Plans">

        <div className="planCard">
          <h2 className="allList">AJMAN OFFSHORE</h2>
          <div className="price">
            <h1>$2,997</h1>
            <span>One Time Payment</span>
          </div>
          <p className="allList">Ajman Offshore New Company <br />
            formation includes
          </p>
          <ul>
            <li className="list"><img src={right} alt="" />Attestation Charges</li>
            <li className="list"><img src={right} alt="" />Registered Agent</li>
            <li className="list"><img src={right} alt="" />Registered Office</li>
            <li className="list"><img src={right} alt="" />Varal Administrative</li>
            <li className="list"><img src={right} alt="" />Preparing Statutory File</li>
            <li className="list"><img src={right} alt="" />Liasing with Registration Authorities</li>
            <li className="list"><img src={right} alt="" />Due Diligence Appraisal</li>
            <li className="list"><img src={right} alt="" />Keeping The Register</li>
            <li className="list"><img src={right} alt="" />Seal Charges</li>
            <li className="list"><img src={right} alt="" />Certificate of Good Standing</li>
          </ul>
          <button className="allList">Continue</button>
        </div>


        <div className="planCard">
          <h2 className="allList">RANK ICC</h2>
          <div className="price">
            <h1>$2,997</h1>
            <span>One Time Payment</span>
          </div>
          <p className="allList">Rak Icc New Company formation <br />
            includes
          </p>
          <ul>
            <li className="list"><img src={right} alt="" />Attestation Charges</li>
            <li className="list"><img src={right} alt="" />Registered Agent</li>
            <li className="list"><img src={right} alt="" />Registered Office</li>
            <li className="list"><img src={right} alt="" />Varal Administrative</li>
            <li className="list"><img src={right} alt="" />Preparing Statutory File</li>
            <li className="list"><img src={right} alt="" />Liasing with Registration Authorities</li>
            <li className="list"><img src={right} alt="" />Due Diligence Appraisal</li>
            <li className="list"><img src={right} alt="" />Keeping The Register</li>
            <li className="list"><img src={right} alt="" />Seal Charges</li>
            <li className="list"><img src={right} alt="" />Certificate of Good Standing</li>
          </ul>
          <button className="allList">Continue</button>
        </div>


        <div className="planCard">
          <h2 className="allList">SHARJAH MEDIA CITY</h2>
          <div className="price">
            <h1>$4,997</h1>
            <span>One Time Payment</span>
          </div>
          <p className="allList">Sharjah Media City New <br />
            Company formation include
          </p>
          <ul>
            <li className="list"><img src={right} alt="" />Attestation Charges</li>
            <li className="list"><img src={right} alt="" />Registered Agent</li>
            <li className="list"><img src={right} alt="" />Registered Office</li>
            <li className="list"><img src={right} alt="" />Varal Administrative</li>
            <li className="list"><img src={right} alt="" />Preparing Statutory File</li>
            <li className="list"><img src={right} alt="" />Liasing with Registration Authorities</li>
            <li className="list"><img src={right} alt="" />Due Diligence Appraisal</li>
            <li className="list"><img src={right} alt="" />Keeping The Register</li>
            <li className="list"><img src={right} alt="" />Seal Charges</li>
            <li className="list"><img src={right} alt="" />Certificate of Good Standing</li>
          </ul>
          <button className="allList">Continue</button>
        </div>
      </div>
      <div className="planAfter">
        <img id="small" src={small} alt="/" />
        <img id="big" src={big} alt="/" />
        <img id="arc" src={arc} alt="/" />
      </div>
    </>
  );
}
